<template>
    <div v-show="isVisible"
         v-if="isVisible"
         :id="['tagForm-' + hotspot.hotspotId]">
        <KeepAlive>
            <component :is="templateForm.template"
                       :store="store"
                       :configuration-data="hotspot.configurationData"
                       :formDescription="hotspot.hotspotAction.lightboxDescription"
                       :formPosition="hotspot.hotspotFormPositions.cssFormPosition"
                       :formRequired="formRequired"
                       :formTitle="hotspot.hotspotAction.lightboxTitle"
                       :hotspot="getHotspot"
                       :hotspotEmailTemplateId="hotspot.hotspotEmailTemplates ? hotspot.hotspotEmailTemplates.hotspotEmailTemplateId : 0"
                       :identifierId="hotspot.hotspotId"
                       :key="templateForm._uid"
                       :translateLabels="translateLabels"
                       :typeIdentifier="'hotspot'"
                       @setClose="closeModal"
            ></component>
        </KeepAlive>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { v1 as uuidv1 } from 'uuid';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import templateDefault from './templates/template-default.vue';
import template2 from './templates/template-2.vue';
import template3 from './templates/template-3.vue';
import template4 from './templates/template-4.vue';
import template5 from './templates/template-5.vue';
import template6 from './templates/template-6.vue';
import template7 from './templates/template-7.vue';
import template8 from './templates/template-8.vue';
import template9 from './templates/template-9.vue';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS
const props = defineProps({
    hotspot: {
        type: Object,
        required: true,
    },
    translateLabels: {
        type: Object,
        required: true,
    },
});

// COMPONENTS
const templateComponents = {
    'template-default': templateDefault,
    'template2': template2,
    'template3': template3,
    'template4': template4,
    'template5': template5,
    'template6': template6,
    'template7': template7,
    'template8': template8,
    'template9': template9,
};

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const formRequired = computed(() => {
    return Boolean(props.hotspot.hotspotRequired || store.isHotspotRegisterType(props.hotspot));
});

const getHotspot = computed(() => {
    return props.hotspot ? props.hotspot : null;
});

const isVisible = computed(() => {
    if (!store.getActiveHotspot) {
        return false;
    }
    $('#bottom-button-bar').css({
        opacity: 1, bottom: -50, padding: 0, transition: '0.3s',
    });
    const isThisHotspot = props.hotspot.hotspotId === store.getActiveHotspot.hotspotId;
    const questions = store.getQuestionsByHotspot(props.hotspot.hotspotId, 'large');
    //Evita que se despliegue el formulario si no tiene ninguna pregunta asociada
    if (isThisHotspot && questions.length === 0) {
        closeModal();
        return false;
    }

    return isThisHotspot;
});

/*const pages = computed(() => {
    if (props.hotspot.pagesForm > 0) {
        return (props.hotspot.pagesForm + 1);
    }
    return props.hotspot.pagesForm;
});*/

const templateForm = computed(() => {
    let templateComponent = templateDefault; // Default fallback
    let templateKey = 'template-default';

    // Si hay un template específico configurado
    if (props.hotspot.templateForms && props.hotspot.templateForms.skeletonHtml) {
        templateKey = props.hotspot.templateForms.skeletonHtml;
        templateComponent = templateComponents[templateKey] || templateDefault;
    }

    return {
        template: templateComponent,
        _uid: uuidv1(),
    };
});

// METHODS
const closeModal = () => {
    $('#bottom-button-bar').css({opacity: 1, bottom: -1, transition: '0.3s'});
    store.addActiveHotspot(null);
    store.getPlayer.play();
};

// LIFECYCLE HOOKS
// todo: borrar
// onMounted(() => {
//     let questionData = {
//         'id': props.hotspot.hotspotId,
//         'type': 'hotspot',
//         'data': store.getQuestionsByHotspot(props.hotspot.hotspotId, 'large')
//     }
//     store.setFormQuestions(questionData);
// });
</script>
